import { ActionController, ActionControllerEvent, ActionControllerEventName } from '@g.frame/common.action_controller';
import { Ray, Sphere, Vector3 } from 'three';
export class FingerTouchActionController extends ActionController {
    constructor() {
        super();
        this.config = {
            minRaycasterDistance: 0,
            maxRaycasterDistance: 0.03
        };
    }
    init(oculusQuestModel, questHandView) {
        this.oculusQuestModel = oculusQuestModel;
        this.questHandView = questHandView;
        this.onMove = (event) => {
            const position = new Vector3();
            if (questHandView.fingerTip) {
                questHandView.fingerTip.localToWorld(position);
            }
            this.updateFinger(new Sphere(position, 0.005));
        };
        // Subscribe on events
        this.oculusQuestModel.on('move', this.onMove);
    }
    dispose() {
        this.oculusQuestModel.off('move', this.onMove);
    }
    updateFinger(sphere, controllerNumber) {
        var _a;
        for (let i = 0; i < this.events.length; i++) {
            const { eventName, object } = this.events[i];
            if (eventName !== ActionControllerEventName.buttonDown
                && eventName !== ActionControllerEventName.buttonUp)
                continue;
            if (!((_a = object === null || object === void 0 ? void 0 : object.userData) === null || _a === void 0 ? void 0 : _a.fingerTouchData))
                continue;
            const parentMatrixWorld = object.matrixWorld.clone().invert();
            const localSphere = sphere.clone().applyMatrix4(parentMatrixWorld);
            if (localSphere.intersectsBox(object.userData.fingerTouchData.box3)) {
                if (!object.userData.fingerTouchData.buttonDown) {
                    object.userData.fingerTouchData.buttonDown = true;
                    super.fire(ActionControllerEventName.buttonDown, object, new ActionControllerEvent(ActionControllerEventName.buttonDown, {
                        controllerNumber: 1,
                        context: this,
                        ray: new Ray()
                    }));
                }
            }
            else if (object.userData.fingerTouchData.buttonDown) {
                object.userData.fingerTouchData.buttonDown = false;
                super.fire(ActionControllerEventName.buttonUp, object, new ActionControllerEvent(ActionControllerEventName.buttonUp, {
                    controllerNumber: 1,
                    context: this,
                    ray: new Ray()
                }));
            }
        }
    }
    update(eventName, raycaster, controllerNumber) {
        console.warn('This class is simplified and doesn\'t have any update class');
    }
}
